import angular from 'angular';

/**
 * Service:Day abbreviation
 * @public getFormattedDay
 * @param {string} type - type of abbreviation required
 * @param {string} day - abbreviated day uses one or two letters
 */
export const DaysServiceModule = angular.module('acme.common.service.days', [])
.service('DaysService', [ function() {

      var week = {
        M : function (type) {
          return setFormatDay(type, 'Monday');
        },
        Tu : function (type) {
          return setFormatDay(type, 'Tuesday');
        },
        W : function (type) {
          return setFormatDay(type, 'Wednesday');
        },
        Th : function (type) {
          return setFormatDay(type, 'Thursday');
        },
        F : function (type) {
          return setFormatDay(type, 'Friday');
        },
        Sa : function (type) {
          return setFormatDay(type, 'Saturday');
        },
        Su : function (type) {
          return setFormatDay(type, 'Sunday');
        }
      };


      function setFormatDay(type, day) {
         switch (type) {
           case 'one':
             day = (day === 'Monday' || day === 'Wednesday' || day === 'Friday') ? day.match(/^.{0,1}/)[0] : day.match(/^.{0,2}/)[0];
             break;
           case 'three':
             day = day.match(/^.{0,3}/)[0];
             break;
           case 'full':
             day = day;
             break;
         }
         return day;
       }

      function getFormattedDay(type, day) {
          return week[day](type);
      }

      return {
       getFormattedDay : getFormattedDay
      };

}]).name;
